<template>
<div>
  <b-container fluid>
    <b-row>
     <b-col>
     <!--card-->
        
          <div id="departureDiv">

          <b-table hover 
            selectable 
            select-mode="single" 
            :items="form.passingTimes" 
            :responsive="false"
            :fields="fields"
            :small="true"
            ref="departureList"
            primary-key="tunnus">
            
            <template v-slot:cell(ohitusaika)="{ item, index, field: { key } }">
                <b-form-group v-if="index == 0">
                    <div class="w-25">
                        <input type="text" v-model="item[key]" :disabled="true"  />
                    </div>
                </b-form-group>
                <b-form-group v-if="index > 0">
                    <div class="w-25">
                        <input type="text" v-model="item[key]" @input="updateTimes(index)" />
                    </div>
                </b-form-group>
            </template>
                        
          </b-table> 
          </div> 
          <br/>
          
          <FormButtons
            @submit="onSavePassingTimes" 
            :reset="false" 
            :remove="false" 
            :disableSubmit="loading" />
          <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
        <!--/card-->
      </b-col>
     </b-row>

   </b-container>
</div>
  
</template>

<script>
import timetable from '@/store/timetable/timetable'
import i18n from '@/i18n'
import moment from 'moment';
import FormButtons from '@/components/Misc/FormButtons'

export default {
    components: {
        FormButtons
    },
    data() {
        return {
            form: {
                passingTimes: [],
            },
            fields: [
                { key: "jarjestys", label:""},
                { key: "pysakki" , label: this.$t('route_view.stop'), sortable: true },
                { key: "pysakkinimi" , label: this.$t('routestop.name'), sortable: true},
                { key: "ohitusaika", label: this.$t('routestop.passing_time')}                
            ],
            sortBy:"ohitusaika",            
            selected: [],
            originalPassingTimes: [],
            formType: "new",            
            firstStopPassTime: 0,            
            itemTemplate: null,
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }   
    },
    props: {
        item: {
            required: true,
        },
        action: { default: "new" }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.getPassingTimes(this.item);
    },
    watch: {
        item: function(item) {
            this.getPassingTimes(item);
            this.ok = this.error = this.loading = false;            
        },
    }, 
    computed: {
        delModalTitle() {
            return this.$t("departure.delete.title")
        },
        formTitle(){
            return i18n.t('item.' + this.formType);
        },        
        route() {
            return this.form.tunnus;
        },
        formattedItems() {
            const formattedPassingTimes = JSON.parse(JSON.stringify(this.form.passingTimes));

            for( let passingTime of formattedPassingTimes) {
                if( passingTime.ohitusaika && moment(passingTime.ohitusaika, "HH:mm", true).isValid() ) {
                    passingTime.ohitusaika = moment(passingTime.ohitusaika, "HH:mm").utcOffset(0).format("YYYY-MM-DD[T]HH:mm:ss");
                } 
            }            
            return formattedPassingTimes; 
        }               
    },    
    methods: {
        getPassingTimes(item) {
            this.$store.dispatch('timetable/getPassingTimes' , JSON.stringify(item) ).then( response => {
                this.form.passingTimes = response.data.departures;
                this.saveOriginalPassingTimes(this.form.passingTimes);
            });        
        },
        saveOriginalPassingTimes(items) {
            this.originalPassingTimes = [];
            for (let p of items) {
               p.ohitusaika = this.departureTime(p.ohitusaika);
               this.originalPassingTimes.push(p.ohitusaika);                            
            }
        },
        getTimeAsMinutes: function(timeStr) {
            const timeArray = timeStr.split(":");                     
            return parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);            
        },
        updateTimes: function(index){
            const newPassingTime = this.form.passingTimes[index].ohitusaika; 

            if( newPassingTime.length === 5 && newPassingTime[2] === ':' ) {
                const difference =  this.getTimeAsMinutes(newPassingTime) - this.getTimeAsMinutes(this.originalPassingTimes[index]);
                
                for (let item of this.form.passingTimes) {
                    if( item.jarjestys > index ) {
                        const newTime = this.getTimeAsMinutes(this.originalPassingTimes[item.jarjestys - 1]) + difference; 
                        const hours = Math.floor(newTime / 60);
                        const minutes = newTime - hours * 60;
                        let timeString = hours < 10 ? "0" + hours : ( hours >= 24 ? hours - 24 : hours );
                        timeString+= ":" + (minutes < 10 ? "0" + minutes : minutes);
                        item.ohitusaika = timeString; 
                    }
                }
            }
        },
        departureTime: function(item) {
            if( item ) {
                const timeArray = item.split("T")[1].split(":");                     
                const departureTime = parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);
                const hours = Math.floor(departureTime / 60);
                const minutes = departureTime - hours * 60;
                let timeStr = hours < 10 ? "0" + hours : hours;
                timeStr+= ":" + (minutes < 10 ? "0" + minutes : minutes); 
                return timeStr; 
            } else
                return "";
        },
        onSavePassingTimes() {
            if( event ) 
                event.preventDefault();   
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('timetable/savePassingTimes' , this.formattedItems).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.$emit('refreshPassingTimes', this.item.reitti);
                })
            }, 1000);
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#departureDiv {
  height: 40em;
  overflow: auto;
}
</style>

